import React, { useEffect, useRef } from 'react';
import { useMediaSource } from '@pole-journal-web/media-source';
import { StoreType } from '@pole-journal/aws-amplify/src/storage';
import {
    AvatarRoot,
    AvatarLetter,
    ProfileImage
} from './styled';

export const COVER_PHOTO_WIDTH = 16;
export const COVER_PHOTO_HEIGHT = 9;

export const UserProfilePhoto = ({
    size,
    username,
    userId
}) => {
    const {
        mediaSource,
        thumbnailSource,
        setMediaSource
    } = useMediaSource({
        id: userId,
        storeType: StoreType.USER_AVATAR
    });

    const imageChangedDependenciesRef = useRef(null);
    imageChangedDependenciesRef.current = { setMediaSource };
    useEffect(() => {
        const { setMediaSource } = imageChangedDependenciesRef.current;
        setMediaSource(null);
    }, [userId]);

    return (
        <AvatarRoot
            size={size}
            hasBorder={!mediaSource}
        >
            {!mediaSource?.uri && (
                <AvatarLetter size={size}>
                    {username[0]}
                </AvatarLetter>
            )}
            {mediaSource?.uri && (
                <ProfileImage
                    shouldDisplaySkeleton
                    shouldBlurThumbnail
                    key={mediaSource.uri}
                    thumbnailSource={thumbnailSource}
                    source={mediaSource}
                    resizeMode='cover'
                    width={size}
                    height={size}
                />
            )}
        </AvatarRoot>
    );
};
